import * as React from 'react';

function SvgMail48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 7H48L30.7704 22.9293L42.7647 35.3521L41.4617 36.6102L29.44 24.1592L26.149 27.2019C24.9825 28.2675 23.0272 28.2762 21.8511 27.2019L18.56 24.1592L6.53837 36.6102L5.23531 35.3521L17.2297 22.9293L1.95894 8.81132H1.81132V39.6038H46.1887L46 8.86L48 7V41.4151H0V7ZM43.3726 8.81132H4.62736C10.7908 14.5096 16.7839 20.3977 23.1182 25.9054C23.6172 26.3296 24.4153 26.3217 24.9063 25.8837L43.3726 8.81132Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default SvgMail48;
